import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

@Injectable()
export class SharedLinkUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    // Old links append auction details to the ID. Remove them before Angular parses
    // parentheses as secondary outlets, preserving any query parameters and fragment.
    const normalizedUrl = url.replace(/^(\/?shared\/[^/?#\s]+?)(?:\s|%20)[^?#]*/i, '$1');

    return super.parse(normalizedUrl);
  }
}
